import { ContentType } from '@medplum/core';
import type { MedplumClient } from '@medplum/core';
import type { Identifier } from '@medplum/fhirtypes';

import { config } from '../config';

const FEEDBACK_AND_BUG_REPORTS_BOT: Identifier = {
  system: 'https://unify.health/bots',
  value: 'feedback-and-bug-reports',
};

export type BugReportEnvironment = 'LOCAL' | 'DEV' | 'PROD';

/** LOCAL = local dev server; PROD = production build; DEV = any other deployed build. */
export function resolveBugReportEnvironment(): BugReportEnvironment {
  if (import.meta.env.DEV) return 'LOCAL';
  if (config.isProduction) return 'PROD';
  return 'DEV';
}

function getBotTarget(): string | Identifier {
  const id = import.meta.env.VITE_MEDPLUM_FEEDBACK_AND_BUG_REPORTS_BOT_ID?.trim();
  if (id) return id;
  return FEEDBACK_AND_BUG_REPORTS_BOT;
}

export interface PortalBugReportBotInput {
  summary: string;
  details: string;
  screenshotBase64: string;
  mimeType: 'image/jpeg';
  pagePath: string;
  environment: BugReportEnvironment;
}

export interface PortalBugReportBotResult {
  ok: boolean;
}

export async function submitPortalBugReport(
  medplum: MedplumClient,
  input: PortalBugReportBotInput,
): Promise<PortalBugReportBotResult> {
  return medplum.executeBot(
    getBotTarget(),
    { kind: 'bug', ...input },
    ContentType.JSON,
  ) as Promise<PortalBugReportBotResult>;
}
